import { request } from "@umijs/max";

// 获取二级商户列表
export async function getBillPage({
  pageSize,
  current,
  filter,
  sorter,
}: {
  pageSize: number;
  current: number;
  filter: API.FormValues;
  sorter: string;
}) {
  return request("/api/super/bill/page", {
    method: "POST",
    data: {
      pageSize,
      current,
      filter,
      sorter,
    },
  });
}

// 获取二级商户详情
export async function getBillInfo(values: API.FormValues) {
  return request("/api/super/bill/info", {
    method: "POST",
    data: values,
  });
}


// 查询支付状态
export async function queryBillStatus(values: API.FormValues) {
  return request("/api/super/bill/query", {
    method: "POST",
    data: values,
  });
}